import React, { Component } from "react";
import { DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";

export default class Dropdown extends React.Component {

    constructor(props) {
        super(props);
    }

    handleSelectPrescription = (evt) => {

        var presciption;
        //////// ENDURANCE ////////
        var endurance3x12     = [[1,2,3,4,5,6,7,8,9,10],[12,12,12],[60,60,60],["00:30","00:30","00:30"]];//["00:30","00:30","00:30"]];//[3,12,.6]; // 30 secs rest
        var endurance3x15     = [[1,2,3,4,5,6,7,8,9,10],[15,15,15],[50,50,50],["00:30","00:30","00:30"]];
        var endurance3x20     = [[1,2,3,4,5,6,7,8,9,10],[20,20,20],[40,40,40],["00:30","00:30","00:30"]];

        var endurance3x30sec  = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[30,30,30],["00:00","00:00","00:00"]]; // 0 secs rest
        var endurance3x45sec  = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[45,45,45],["00:00","00:00","00:00"]]; // 0 secs rest
        var endurance3x60sec  = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[60,60,60],["00:00","00:00","00:00"]]; // 0 secs rest
        var endurance3x90sec  = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[90,90,90],["00:00","00:00","00:00"]]; // 0 secs rest
        // convert below to new rest format: mm:ss

        //////// HYPERTROPHY ////////
        var hypertrophy3x6    = [[1,2,3,4,5,6,7,8,9,10],[6,6,6],[75,75,75], ["01:30","01:30","01:30",]];
        var hypertrophy3x6x85 = [[1,2,3,4,5,6,7,8,9,10],[6,6,6],[85,85,85], ["00:60","00:60","00:60",]];
        var hypertrophy3x8   = [[1,2,3,4,5,6,7,8,9,10],[8,8,8],[80,80,80], ["01:15","01:15","01:15"]];
        var hypertrophy3x10  = [[1,2,3,4,5,6,7,8,9,10],[10,10,10],[75,75,75], ["01:00","01:00","01:00"]];
        var hypertrophy3x12  = [[1,2,3,4,5,6,7,8,9,10],[12,12,12],[67,67,67], ["00:30","00:30","00:30"]];
        var hypertrophy4x8   = [[1,2,3,4,5,6,7,8,9,10],[8,8,8,8],[78,78,78,78], ["00:30","00:30","00:30","00:30"]];
        var hypertrophy4x10  = [[1,2,3,4,5,6,7,8,9,10],[10,10,10,10],[70,70,70,70], ["00:30","00:30","00:30","00:30"]];

        //////// STRENGTH ////////
        var strength3x3      = [[1,2,3,4,5,6,7,8,9,10],[3,3,3],[85,85,85], ["02:00","02:00","02:00"]];
        var strength3x5      = [[1,2,3,4,5,6,7,8,9,10],[5,5,5],[80,80,80], ["02:00","02:00","02:00"]];  // 80% and 2 minutes rest

        //???var strength3x5      = [[1,2,3,4,5,6,7,8,9,10],[5,5,5],[.8,.8,.8], ["02:00","02:00","02:00"]];
        var strength5x3      = [[1,2,3,4,5,6,7,8,9,10],[3,3,3,3,3],[85,85,85,85,85], ["02:00","02:00","02:00","02:00","02:00"]];
        var strength5x4      = [[1,2,3,4,5,6,7,8,9,10],[4,4,4,4,4],[85,85,85,85,85], ["02:00","02:00","02:00","02:00","02:00"]];
        var strength5x5      = [[1,2,3,4,5,6,7,8,9,10],[5,5,5,5,5],[85,85,85,85,85], ["02:00","02:00","02:00","02:00","02:00"]];
        var strength5x6      = [[1,2,3,4,5,6,7,8,9,10],[6,6,6,6,6],[85,85,85,85,85], ["02:00","02:00","02:00","02:00","02:00"]];

        //////// POWER ////////
        var power3x1         = [[1,2,3,4,5,6,7,8,9,10],[1,1,1],[90,90,90],["02:00","02:00","02:00"]]; // 2 min rest
        var power3x2         = [[1,2,3,4,5,6,7,8,9,10],[2,2,2],[85,85,85],["02:00","02:00","02:00"]];
        var power3x3         = [[1,2,3,4,5,6,7,8,9,10],[3,3,3],[80,80,80],["02:00","02:00","02:00"]];
        var power4x1         = [[1,2,3,4,5,6,7,8,9,10],[1,1,1,1],[85,85,85,85],["02:00","02:00","02:00","02:00"]];
        var power4x2         = [[1,2,3,4,5,6,7,8,9,10],[2,2,2,2],[70,70,70,70],["02:00","02:00","02:00","02:00"]];
        var power4x3         = [[1,2,3,4,5,6,7,8,9,10],[3,3,3,3],[65,65,65,65],["02:00","02:00","02:00","02:00"]];
        var power5x1         = [[1,2,3,4,5,6,7,8,9,10],[1,1,1,1,1],[90,90,90,90,90],["02:00","02:00","02:00","02:00","02:00"]];
        var power5x2         = [[1,2,3,4,5,6,7,8,9,10],[2,2,2,2,2],[85,85,85,85,85],["02:00","02:00","02:00","02:00","02:00"]];
        var power5x3         = [[1,2,3,4,5,6,7,8,9,10],[3,3,3,3,3],[80,80,80,80,80],["02:00","02:00","02:00","02:00","02:00"]];
        var power5x4         = [[1,2,3,4,5,6,7,8,9,10],[4,4,4,4,4],[80,80,80,80,80],["02:00","02:00","02:00","02:00","02:00"]];
        var power5x5x70      = [[1,2,3,4,5,6,7,8,9,10],[5,5,5,5,5],[70,70,70,70,70],["02:00","02:00","02:00","02:00","02:00"]];
        var power5x5x75      = [[1,2,3,4,5,6,7,8,9,10],[5,5,5,5,5],[75,75,75,75,75],["02:00","02:00","02:00","02:00","02:00"]];
        var power5x5x65      = [[1,2,3,4,5,6,7,8,9,10],[5,5,5,5,5],[65,65,65,65,65],["02:00","02:00","02:00","02:00","02:00"]];  // 2 min rest


        var power10x1        = [[1,2,3,4,5,6,7,8,9,10],[1,1,1,1,1,1,1,1,1,1],[85,85,85,85,85,85,85,85,85,85],["02:00","02:00","02:00","02:00","02:00","02:00","02:00","02:00","02:00","02:00"]];  // 2 min rest

        //////// STABILIZATION ////////
        var stabilization3x12_1 = [[1,2,3,4,5,6,7,8,9,10],[12,12,12],[60,60,60],["00:30","00:30","00:30"]]; // 30 seconds
        var stabilization3x15_1 = [[1,2,3,4,5,6,7,8,9,10],[15,15,15],[50,50,50],["00:30","00:30","00:30"]];
        var stabilization3x20_1 = [[1,2,3,4,5,6,7,8,9,10],[20,20,20],[40,40,40],["00:30","00:30","00:30"]];

        /* 3 x 45 seconds won't work on admin side right now */
        var stabilization3x10 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[10,10,10],["00:00","00:00","00:00"]];
        var stabilization3x15 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[15,15,15],["00:00","00:00","00:00"]];
        var stabilization3x20 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[20,20,20],["00:00","00:00","00:00"]];
        var stabilization3x30 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[30,30,30],["00:00","00:00","00:00"]];
        var stabilization3x45 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[45,45,45],["00:00","00:00","00:00"]];
        var stabilization3x60 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[60,60,60],["00:00","00:00","00:00"]];
        var stabilization3x90 = [[1,2,3,4,5,6,7,8,9,10],[0,0,0],[90,90,90],["00:00","00:00","00:00"]];

        var movementPrep1x15 = [[1,2,3,4,5,6,7,8,9,10],[15],[0],["00:00"]]; // secs
        var movementPrep1x20 = [[1,2,3,4,5,6,7,8,9,10],[20],[0],["00:00"]]; // secs
        var movementPrep1x30 = [[1,2,3,4,5,6,7,8,9,10],[30],[0],["00:00"]]; // secs
        var movementPrep1x45 = [[1,2,3,4,5,6,7,8,9,10],[45],[0],["00:00"]]; // secs
        var movementPrep1x60 = [[1,2,3,4,5,6,7,8,9,10],[60],[0],["00:00"]]; // secs

        var movementPrep1x6  = [[1,2,3,4,5,6,7,8,9,10],[6],[0],["00:00"]]; // breathes
        var movementPrep1x8  = [[1,2,3,4,5,6,7,8,9,10],[8],[0],["00:00"]]; // breathes

        var movementPrep1x5Reps  = [[1,2,3,4,5,6,7,8,9,10],[5],[0],["00:00"]]; // reps
        var movementPrep1x10Reps = [[1,2,3,4,5,6,7,8,9,10],[10],[0],["00:00"]]; // reps
        var movementPrep1x15Reps = [[1,2,3,4,5,6,7,8,9,10],[15],[0],["00:00"]]; // reps

        var movementPrep1x1Laps  = [[1,2,3,4,5,6,7,8,9,10],[1],[0],["00:00"]]; // lap
        var movementPrep1x2Laps  = [[1,2,3,4,5,6,7,8,9,10],[2],[0],["00:00"]]; // lap

        switch(evt) {
            case "endurance3x12":
                presciption = endurance3x12;
                break;
            case "endurance3x15":
                presciption = endurance3x15;
                break;
            case "endurance3x20":
                presciption = endurance3x20;
                break;
            case "endurance3x30sec":
                presciption = endurance3x30sec;
                break;
            case "endurance3x45sec":
                presciption = endurance3x45sec;
                break;
            case "endurance3x60sec":
                presciption = endurance3x60sec;
                break;
            case "endurance3x90sec":
                presciption = endurance3x90sec;
                break;
            case "hypertrophy3x6":
                presciption = hypertrophy3x6;
                break;

            case "hypertrophy3x6x85":
                presciption = hypertrophy3x6x85;
                break;

            case "hypertrophy3x8":
                presciption = hypertrophy3x8;
                break;
            case "hypertrophy3x10":
                presciption = hypertrophy3x10;
                break;
            case "hypertrophy3x12":
                presciption = hypertrophy3x12;
                break;
            case "hypertrophy4x8":
                presciption = hypertrophy4x8;
                break;
            case "hypertrophy4x10":
                presciption = hypertrophy4x10;
                break;
            case "strength3x3":
                presciption = strength3x3;
                break;
            case "strength3x5":
                presciption = strength3x5;
                break;
            case "strength5x3":
                presciption = strength5x3;
                break;
            case "strength5x4":
                presciption = strength5x4;
                break;
            case "strength5x5":
                presciption = strength5x5;
                break;
            case "strength5x6":
                presciption = strength5x6;
                break;
            case "stabilization3x12_1":
                presciption = stabilization3x12_1;
                break;
            case "stabilization3x15_1":
                presciption = stabilization3x15_1;
                break;
            case "stabilization3x20_1":
                presciption = stabilization3x20_1;
                break;
            case "stabilization3x10":
                presciption = stabilization3x10;
                break;
            case "stabilization3x15":
                presciption = stabilization3x15;
                break;
            case "stabilization3x20":
                presciption = stabilization3x20;
                break;
            case "stabilization3x30":
                presciption = stabilization3x30;
                break;
            case "stabilization3x45":
                presciption = stabilization3x45;
                break;
            case "stabilization3x60":
                presciption = stabilization3x60;
                break;
            case "stabilization3x90":
                presciption = stabilization3x90;
                break;
            case "power3x1":
                presciption = power3x1
                break;
            case "power3x2":
                presciption = power3x2
                break;
            case "power3x3":
                presciption = power3x3
                break;
            case "power4x1":
                presciption = power4x1
                break;
            case "power4x2":
                presciption = power4x2
                break;
            case "power4x3":
                presciption = power4x3
                break;
            case "power5x1":
                presciption = power5x1
                break;
            case "power5x2":
                presciption = power5x2
                break;
            case "power5x3":
                presciption = power5x3
                break;
            case "power5x4":
                presciption = power5x4
                break;
            case "power5x5x70":
                presciption = power5x5x70
                break;
            case "power5x5x75":
                presciption = power5x5x75
                break;
            case "power5x5x65":
                presciption = power5x5x65
                break;
            case "power10x1":
                presciption = power10x1
                break;
            case "movementPrep1x15":
                presciption = movementPrep1x15;
                break;
            case "movementPrep1x20":
                presciption = movementPrep1x20
                break;
            case "movementPrep1x30":
                presciption = movementPrep1x30
                break;
            case "movementPrep1x45":
                presciption = movementPrep1x45
                break;
            case "movementPrep1x60":
                presciption = movementPrep1x60
                break;
            case "movementPrep1x6":
                presciption = movementPrep1x6
                break;
            case "movementPrep1x8":
                presciption = movementPrep1x8
                break;
            case "movementPrep1x5Reps":
                presciption = movementPrep1x5Reps
                break;
            case "movementPrep1x10Reps":
                presciption = movementPrep1x10Reps
                break;
            case "movementPrep1x15Reps":
                presciption = movementPrep1x15Reps
                break;

            case "movementPrep1x1Laps":
                presciption = movementPrep1x1Laps
                break;
            case "movementPrep1x2Laps":
                presciption = movementPrep1x2Laps
                break;
            default:
                presciption = endurance3x12;
                break;
        }

        //// CHANGE Dropdown ID (ie from % of Max to "none") ////
        var row2_dd_id = 2;  // id 2  = reps
        var row3_dd_id = 12; // id 12 = % of max

        if(evt === "endurance3x30sec" || evt === "endurance3x45sec" || evt === "endurance3x60sec" ||  evt === "endurance3x90sec" ||
           evt === "stabilization3x10" || evt === "stabilization3x15" || evt === "stabilization3x20" || evt === "stabilization3x30" ||
           evt === "stabilization3x45" || evt === "stabilization3x60" || evt === "stabilization3x90") {
               row3_dd_id = 21; // id 21 = seconds
        } else if(evt === "movementPrep1x15" || evt === "movementPrep1x20" || evt === "movementPrep1x30" ||
                  evt === "movementPrep1x45" || evt === "movementPrep1x60") {
                row2_dd_id = 21; // id 21 = seconds
                row3_dd_id = 100;  // id 100 = none
        } else if(evt === "movementPrep1x6" || evt === "movementPrep1x8") {
                row2_dd_id = 45; // id 45 = breaths
                row3_dd_id = 100;  // id 100 = none
        } else if(evt === "movementPrep1x5Reps" || evt === "movementPrep1x10Reps" || evt === "movementPrep1x15Reps") {
                row3_dd_id = 100;  // id 100 = none
        } else if(evt === "movementPrep1x1Laps" || evt === "movementPrep1x2Laps") {
                row2_dd_id = 36; // id 36 = laps
                row3_dd_id = 100;  // id 100 = none
        }

        this.props.changeDropdownId(presciption, row2_dd_id, row3_dd_id);

        /*this.setState({
            rowBoxMetrics: presciption
        })*/
    }

    render() {
        return (<div className="dropdownPrescription" >
                    <DropdownButton id="DropdownMeasure"
                                onSelect = {(event) => this.handleSelectPrescription(event)}
                                title    = "Prescription"
                                pullRight>

                                <MenuItem>Endurance</MenuItem>
                                <MenuItem eventKey={"endurance3x12"}><span className="dropdownTabSpace"/>3x12 @ 60% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"endurance3x15"}><span className="dropdownTabSpace"/>3x15 @ 50% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"endurance3x20"}><span className="dropdownTabSpace"/>3x20 @ 40% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"endurance3x30sec"}><span className="dropdownTabSpace"/>3x30 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"endurance3x45sec"}><span className="dropdownTabSpace"/>3x45 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"endurance3x60sec"}><span className="dropdownTabSpace"/>3x60 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"endurance3x90sec"}><span className="dropdownTabSpace"/>3x90 seconds - 0 rest</MenuItem>
                                <MenuItem divider />
                                <MenuItem>Hypertropphy</MenuItem>
                                <MenuItem eventKey={"hypertrophy3x6"}><span className="dropdownTabSpace"/>3x6 @ 75% - 90 seconds rest</MenuItem>
                                <MenuItem eventKey={"hypertrophy3x6x85"}><span className="dropdownTabSpace"/>3x6 @ 85% - 90 seconds rest</MenuItem>
                                <MenuItem eventKey={"hypertrophy3x8"}><span className="dropdownTabSpace"/>3x8 @ 80% - 75 seconds rest</MenuItem>
                                <MenuItem eventKey={"hypertrophy3x10"}><span className="dropdownTabSpace"/>3x10 @ 75% - 60 seconds rest</MenuItem>
                                <MenuItem eventKey={"hypertrophy3x12"}><span className="dropdownTabSpace"/>3x12 @ 67% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"hypertrophy4x8"}><span className="dropdownTabSpace"/>4x8 @ 78% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"hypertrophy4x10"}><span className="dropdownTabSpace"/>4x10 @ 70%  - 30 seconds rest</MenuItem>
                                <MenuItem divider />

                                <MenuItem>Strength</MenuItem>
                                <MenuItem eventKey={"strength3x3"}><span className="dropdownTabSpace"/>3x3 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"strength3x5"}><span className="dropdownTabSpace"/>3x5 @ 80% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"strength5x3"}><span className="dropdownTabSpace"/>5x3 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"strength5x4"}><span className="dropdownTabSpace"/>5x4 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"strength5x5"}><span className="dropdownTabSpace"/>5X5 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"strength5x6"}><span className="dropdownTabSpace"/>5x6 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem divider />

                                <MenuItem>Power</MenuItem>
                                <MenuItem eventKey={"power3x1"}><span className="dropdownTabSpace"/>3x1 @ 90% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power3x2"}><span className="dropdownTabSpace"/>3x2 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power3x3"}><span className="dropdownTabSpace"/>3x3 @ 80% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power4x1"}><span className="dropdownTabSpace"/>4x1 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power4x2"}><span className="dropdownTabSpace"/>4x2 @ 70% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power4x3"}><span className="dropdownTabSpace"/>4x3 @ 65% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x1"}><span className="dropdownTabSpace"/>5x1 @ 90% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x2"}><span className="dropdownTabSpace"/>5x2 @ 85% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x3"}><span className="dropdownTabSpace"/>5x3 @ 80% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x4"}><span className="dropdownTabSpace"/>5x4 @ 80% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x5x70"}><span className="dropdownTabSpace"/>5x5 @ 70% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x5x75"}><span className="dropdownTabSpace"/>5x5 @ 75% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power5x5x65"}><span className="dropdownTabSpace"/>5x5 @ 65% - 2 minutes rest</MenuItem>
                                <MenuItem eventKey={"power10x1"}><span className="dropdownTabSpace"/>10x1 @ 85% - 2 minutes rest</MenuItem>

                                <MenuItem>Stabilization</MenuItem>
                                <MenuItem eventKey={"stabilization3x12_1"}><span className="dropdownTabSpace"/>3x12 @ 60% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x15_1"}><span className="dropdownTabSpace"/>3x15 @ 50% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x20_1"}><span className="dropdownTabSpace"/>3x20 @ 40% - 30 seconds rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x10"}><span className="dropdownTabSpace"/>3x10 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x15"}><span className="dropdownTabSpace"/>3x15 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x20"}><span className="dropdownTabSpace"/>3x20 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x30"}><span className="dropdownTabSpace"/>3x30 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x45"}><span className="dropdownTabSpace"/>3x45 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x60"}><span className="dropdownTabSpace"/>3x60 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"stabilization3x90"}><span className="dropdownTabSpace"/>3x90 seconds - 0 rest</MenuItem>
                                <MenuItem divider />

                                <MenuItem>Movement Prep</MenuItem>
                                <MenuItem eventKey={"movementPrep1x15"}><span className="dropdownTabSpace"/>1x15 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x20"}><span className="dropdownTabSpace"/>1x20 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x30"}><span className="dropdownTabSpace"/>1x30 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x45"}><span className="dropdownTabSpace"/>1x45 seconds - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x60"}><span className="dropdownTabSpace"/>1x60 seconds - 0 rest</MenuItem>

                                <MenuItem eventKey={"movementPrep1x6"}><span className="dropdownTabSpace"/>1x6 breaths - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x8"}><span className="dropdownTabSpace"/>1x8 breaths - 0 rest</MenuItem>

                                <MenuItem eventKey={"movementPrep1x5Reps"}><span className="dropdownTabSpace"/>1x5 reps - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x10Reps"}><span className="dropdownTabSpace"/>1x10 reps - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x15Reps"}><span className="dropdownTabSpace"/>1x15 reps - 0 rest</MenuItem>

                                <MenuItem eventKey={"movementPrep1x1Laps"}><span className="dropdownTabSpace"/>1x1 lap - 0 rest</MenuItem>
                                <MenuItem eventKey={"movementPrep1x2Laps"}><span className="dropdownTabSpace"/>1x2 laps - 0 rest</MenuItem>
                    </DropdownButton>
               </div>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/form/DropdownPrescription.js